export default function Features() {
  return (
    <section id="features" className="py-24 bg-[#F5F6F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#00D4AA]/10 text-[#00D4AA] px-4 py-2 rounded-full mb-6">
            <span className="font-semibold text-sm uppercase tracking-wide">Features</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F36]">
            Why Choose Our VPN
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-6">
          <div className="lg:col-span-2 bg-[#1A1F36] rounded-[35px] p-12 shadow-lg">
            <div className="flex flex-col items-center text-center space-y-6">
              <div className="w-20 h-20 bg-[#00D4AA]/20 rounded-full flex items-center justify-center">
                <i className="ri-lock-2-line text-white text-5xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-white">
                Military-Grade Encryption
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed">
                Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide. Every bit of information transmitted through our VPN is completely secure and unreadable to anyone trying to intercept it.
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 flex flex-col gap-6">
            <div className="bg-[#00D4AA]/10 rounded-[35px] p-8 shadow-md flex items-center gap-6">
              <div className="w-16 h-16 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-flashlight-line text-white text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                  Ultra-Fast Connection
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Experience blazing-fast speeds with our optimized server infrastructure. Stream, download, and browse without any lag or buffering.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-[35px] p-8 shadow-md border-2 border-[#00D4AA] flex items-center gap-6">
              <div className="w-16 h-16 bg-[#1A1F36] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-earth-line text-white text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                  Global Coverage
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Connect to servers across the globe for unrestricted access to content. Bypass geo-restrictions and enjoy true internet freedom.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#00D4AA] to-[#00BF99] rounded-[35px] p-8 shadow-md flex items-center gap-6">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-eye-off-line text-white text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Complete Privacy
                </h3>
                <p className="text-white/90 leading-relaxed">
                  No logs, no tracking, no compromises. Your online activities are your business, and we keep it that way with our strict no-log policy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
